<template>
  <div class="dashboard__overview-card team-content">
    <div class="team__tab-header">
      <div class="header__top">
        <div>
          <p class="name">{{ teamMem.firstname }}</p>
          <p class="email">{{ teamMem.email }}</p>
        </div>
        <svgicon
          icon="arrow-down-thin"
          class="arrow"
          @click="() => (open = !open)"
        ></svgicon>
      </div>
      <div class="header__bottom">
        <div class="role__list" v-show="teamMem.roles.length">
          <div
            v-for="(role, index) in teamMem.roles"
            :key="index"
            class="role__list-item"
          >
            {{ role.role.name }}
            <svgicon
              icon="cancel"
              class="role__list-item-remove"
              @click="$emit('remove-role', role.id)"
            ></svgicon>
          </div>
        </div>
        <svgicon
          icon="trash-icon"
          class="trash"
          @click="$emit('delete-user')"
        ></svgicon>
      </div>
    </div>
    <div v-if="open" class="team__tab-content">
      <select
        v-model="selectedRole"
        class="role-dropdown"
        @change="$emit('update-roles', selectedRole)"
      >
        <option value="" disabled>
          Add a new role
        </option>
        <option v-for="role in roleList" :key="role.id" :value="role">{{
          role.name
        }}</option>
      </select>
      <div class="role__container" v-show="teamMem.roles.length">
        <p class="title">Edit roles</p>
        <div class="permission__list">
          <div
            v-for="(role, index) in teamMem.roles"
            :key="index"
            class="permission__list-item"
          >
            <div>
              <p class="role">
                {{ role.role.name }}
                <svgicon
                  icon="spinner"
                  v-if="loading && role.role.id == roleId"
                  class="button__loader_blue"
                  style="margin-left: 10px;"
                ></svgicon>
              </p>
              <div class="permissions">
                <custom-checkbox
                  v-for="el in actions"
                  :key="el.id"
                  :value="hasPermission(role.permissions, el.id)"
                  @input="value => handleChange(role.role.id, el.id, value)"
                >
                  <span>{{ el.name }}</span>
                </custom-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addAdminPermission,
  removeAdminPermission
} from "../../../services/dashboard";
import CustomCheckbox from "../resuables/custom-checkbox.vue";
export default {
  components: { CustomCheckbox },
  props: {
    teamMem: {
      required: true,
      type: Object
    },
    roleList: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      roleId: null,
      open: false,
      selectedRole: "",
      actions: [
        { id: 1, name: "Create", default: false },
        { id: 2, name: "Read", default: false },
        { id: 3, name: "Update", default: false },
        { id: 4, name: "Delete", default: false }
      ]
    };
  },
  methods: {
    async handleChange(roleId, permissionId, ischecked) {
      this.roleId = roleId;
      let response;
      try {
        this.loading = true;
        if (ischecked) {
          response = await addAdminPermission({
            userId: this.teamMem.id,
            roleId,
            permissionId
          });
          if (response.data.statusCode == 201) {
            this.$notification.success({
              message: response.data.message
            });
          }
        } else {
          const role = this.teamMem.roles.find(r => r.roleId === roleId);
          if (role) {
            const perm = role.permissions.find(
              el => el.permissionId === permissionId
            );
            response = await removeAdminPermission(perm.id);
            if (response.statusCode === 200) {
              this.$notification.success({
                message: response.message
              });
            }
          }
        }

        // remove or add permission to user roles
        const role = this.teamMem.roles.find(r => r.roleId === roleId);
        const index = role.permissions.findIndex(
          el => el.permissionId === permissionId
        );
        if (index !== -1) {
          role.permissions.splice(index, 1);
        } else {
          const data = response.data.data;
          role.permissions.push({ ...data });
        }
      } catch (error) {
        this.$notification.error({
          message: "Error occured updating permission"
        });
      } finally {
        this.loading = false;
      }
    },
    hasPermission(permissions, permissionId) {
      return permissions.map(el => el.permissionId).includes(permissionId);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/teamMemberPermission.vue